<!-- お気に入りページ -->
<template>
  <h2 class="com_title1">
    <span>お気に入りページ （よく使う動画・資料）</span>
  </h2>

  <div class="com_topic_list1 com_more1">
    <div
      v-for="item in displayedList"
      :key="item.contentId"
      :class="{ disabled: isProcessing }"
    >
      <div class="meta1">
        <span
          :class="{ com_favorite1: true, selected: item.isFavorite }"
          @click="handleToggleFavorite(item)"
        ></span
        ><span class="com_tag2">{{ item.categoryName }}</span>
      </div>
      <div class="body1">
        <router-link
          :to="`/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`"
          class="com_link1"
        >
          {{ item.title }}
        </router-link>
      </div>
    </div>
  </div>

  <button
    v-if="!showAll && favoritPageListData.length > showCount"
    @click="showAllItems"
    class="com_more_button1"
  >
    もっと見る
  </button>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  getTargetDate,
  getUserInfo,
  toggleFavoritePage,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";
import { useProcessingStore } from "../../store/useProcessingStore";

interface Item {
  contentId: string;
  categoryId: string;
  categoryName: string;
  title: string;
  isFavorite: boolean;
  detailPath: string;
  updateFormPath: string;
}

export default defineComponent({
  name: "FavoritePageComponent",
  setup() {
    const favoritPageListData = ref<Item[]>([]);
    const { agCode, userId } = getUserInfo();
    const showCount = ref(0);
    const showAll = ref(false);
    const processingStore = useProcessingStore(); //状態管理ストア

    const displayedList = computed(() => {
      return showAll.value
        ? favoritPageListData.value
        : favoritPageListData.value.slice(0, showCount.value);
    });

    const showAllItems = () => {
      showAll.value = true;
    };

    onMounted(async () => {
      try {
        outputDebugLogs("お気に入りページ一覧取得");

        // お気に入りページ一覧取得API
        const response = await apiAuthClient.post(
          "/api/FavoritPage/getFavoritePageList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: userId.value,
            agCode: agCode.value,
            targetDate: getTargetDate(""),
          }
        );
        favoritPageListData.value = response.data.favoritListData;
        showCount.value = response.data.showCount;
        outputDebugLogs(
          "お気に入りページ一覧取得成功 件数：" +
            favoritPageListData.value.length
        );
        outputDebugLogs("showCount:" + showCount.value);
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "お気に入りページ一覧取得"));
      } finally {
        //何か入れるかも
      }
    });

    // お気に入り登録・解除
    const toggleFavorite = async (item: Item) => {
      // isProcessingがtrueなら処理をスキップ
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;
      try {
        outputDebugLogs("コンテンツID：" + item.contentId);

        //お気に入り登録・解除
        const result = await toggleFavoritePage(
          item.categoryId,
          item.contentId,
          item.isFavorite,
          "TOP画面"
        );

        if (!result) {
          alert(
            formatMessage(
              messages.ERR_SYS003,
              item.isFavorite ? "お気に入り登録" : "お気に入り解除"
            )
          );
        }

        // 状態を更新
        item.isFavorite = !item.isFavorite;
      } catch (error) {
        console.error("Error toggling favorite:", error);
      } finally {
        await new Promise((resolve) => setTimeout(resolve, 500));
        processingStore.isProcessing = false;
      }
    };

    const handleToggleFavorite = (item: Item) => {
      if (!processingStore.isProcessing) {
        toggleFavorite(item);
      }
    };

    return {
      favoritPageListData,
      showCount,
      displayedList,
      showAllItems,
      showAll,
      toggleFavorite,
      isProcessing: processingStore.isProcessing,
      handleToggleFavorite,
    };
  },
});
</script>
<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>
